module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/~/core-js/library/modules/_is-object.js
// module id = 1114
// module chunks = 0